export default __webpack_public_path__ + "static/media/left2_hover.fee37ddb.svg";